export default __webpack_public_path__ + "static/media/miguel-lopes-6.8998ba61.jpg";